import { render, staticRenderFns } from "./create-project.page.vue?vue&type=template&id=3315bf95&scoped=true&"
import script from "./create-project.page.vue?vue&type=script&lang=js&"
export * from "./create-project.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3315bf95",
  null
  
)

export default component.exports